import React, { Component, useState, useEffect } from 'react';
import CatTreeSelect from "./CatTreeSelect";

const CatSelect=({value,parentId,onSelect,catType})=>{
    return (
        <CatTreeSelect parentId={parentId!=undefined?parentId:0} onSelect={onSelect} value={value} catType={catType}/>
    );
}

export default CatSelect;